import { render } from "./FormOverview.vue?vue&type=template&id=6fe573d5"
import script from "./FormOverview.vue?vue&type=script&lang=js"
export * from "./FormOverview.vue?vue&type=script&lang=js"
script.render = render

export default script